module.exports = __webpack_public_path__ + "static/media/rails.85db1aee.svg";